import { render, staticRenderFns } from "./FinanceTabPlatformPayments.vue?vue&type=template&id=2fbcfac6&scoped=true"
import script from "./FinanceTabPlatformPayments.vue?vue&type=script&lang=js"
export * from "./FinanceTabPlatformPayments.vue?vue&type=script&lang=js"
import style0 from "./FinanceTabPlatformPayments.vue?vue&type=style&index=0&id=2fbcfac6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbcfac6",
  null
  
)

export default component.exports